import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { object, func, number, string, bool } from 'prop-types';
import JobDescriptionSlideout from 'ps-components/JobDescriptionSlideout/JobDescriptionSlideout';
import * as marketPricingActions from '../MarketPricingActions';
import { jdxActions } from '../../HRTMS/JDXUtils';

JobDescription.propTypes = {
  actions: object,
  backToRoute: string.isRequired,
  hideSlideout: func,
  history: object,
  HRTMSEnabled: bool,
  launchDarklyFeatureFlags: object,
  marketPricing: object,
  orgJobCode: string,
  orgJobCodeKey: string,
  orgJobId: number,
  orgJobTitle: string,
  slideout: object
};

const availableRoutes = ['iframe/merit', 'market-analysis/jobs'];

function JobDescription(props) {
  const {
    marketPricing: {
      deleteJobDescriptionLoading,
      uploadJobDescriptionLoading,
      downloadJobDescriptionLoading,
      jobDescriptionError,
      jobDescription: { fileType, previewURL, downloadURL, hasHRTMS }
    }
  } = props;
  const { downloadJobDescription, uploadJobDescription, setJobDescriptionError, resetJobDescription } = props.actions;
  const pathTrack = props.history.location.pathname
    .split('/')
    .filter((el, i) => i === 1 || i === 2)
    .join('/');

  // Use effect is used to ensure that the slideout is closed
  // when switching between "modules" / "components"
  useEffect(() => {
    if (!availableRoutes.includes(pathTrack) && props.slideout.open) closeSlideout();
  }, [pathTrack]);

  function closeSlideout() {
    props.history.push(props.backToRoute);
    props.hideSlideout();
  }

  function createJDXJobDescription() {
    props.history.push(props.backToRoute + '/add-job-description', {
      modal: true,
      modalType: 'JDX_IFRAME',
      modalProps: {
        backToRoute: props.backToRoute + '/job-description',
        className: 'jdexpert__modal',
        jdxAction: jdxActions.ADD_JOB_DESCRIPTION,
        titleText: `JDXpert - ${props.orgJobTitle}`,
        backToText: 'Job Description',
        currentJob: {
          id: props.orgJobId,
          code: props.orgJobCode,
          codeKey: props.orgJobCodeKey
        },
        hideClose: true,
        launchDarklyFeatureFlags: props.launchDarklyFeatureFlags
      },
      component: 'JDX_IFRAME'
    });
  }

  function openJdxModal() {
    props.history.push(props.backToRoute + '/job-description/edit', {
      modal: true,
      modalType: 'JDX_IFRAME',
      modalProps: {
        backToRoute: props.backToRoute + '/job-description',
        className: 'jdexpert__modal',
        jdxAction: jdxActions.JOB_DESCRIPTION,
        titleText: `JDXpert - ${props.orgJobTitle}`,
        backToText: 'Job Description',
        currentJob: {
          id: props.orgJobId,
          code: props.orgJobCode,
          codeKey: props.orgJobCodeKey
        },
        hideClose: true,
        launchDarklyFeatureFlags: props.launchDarklyFeatureFlags
      },
      component: 'JDX_IFRAME'
    });
  }

  const isEditJobDescriptionEnabled = props.HRTMSEnabled && hasHRTMS;
  const isCreateJobDescriptionEnabled = props.HRTMSEnabled && !hasHRTMS;

  const isDeleteJobDescriptionEnabled = !hasHRTMS && downloadURL;

  const isDropzoneEnabledForError = !previewURL && !hasHRTMS;

  const isDropzoneEnabledWithoutJdx = !previewURL && !hasHRTMS && !props.HRTMSEnabled;

  const isPlaceholderEnabled = !previewURL && !hasHRTMS && props.HRTMSEnabled;

  return (
    <JobDescriptionSlideout
      downloadJobDescription={downloadJobDescription}
      downloadURL={downloadURL}
      fileType={fileType}
      handleCloseSlideout={closeSlideout}
      handleDeleteJobDescription={
        isDeleteJobDescriptionEnabled ? () => props.actions.deleteJobDescription(props.orgJobId) : undefined
      }
      handleEditJobDescription={isEditJobDescriptionEnabled ? openJdxModal : undefined}
      handleCreateJobDescription={isCreateJobDescriptionEnabled ? createJDXJobDescription : undefined}
      HRTMSEnabled={props.HRTMSEnabled}
      isDropzoneEnabledForError={isDropzoneEnabledForError}
      isDropzoneEnabledWithoutJdx={isDropzoneEnabledWithoutJdx}
      isLoading={deleteJobDescriptionLoading || uploadJobDescriptionLoading || downloadJobDescriptionLoading}
      isPlaceholderEnabled={isPlaceholderEnabled}
      jobDescriptionError={jobDescriptionError}
      orgJobCode={props.orgJobCode}
      orgJobCodeKey={props.orgJobCodeKey}
      orgJobId={props.orgJobId}
      orgJobTitle={props.orgJobTitle}
      previewURL={previewURL}
      resetJobDescription={resetJobDescription}
      setJobDescriptionError={setJobDescriptionError}
      uploadJobDescription={uploadJobDescription}
    />
  );
}

const mapStateToProps = ({ marketPricing, session }) => {
  return {
    marketPricing: marketPricing.MarketPricingReducer,
    HRTMSEnabled: session.organization?.accountMetaData?.enableHRTMSIntegration
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...marketPricingActions
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(JobDescription);
